module.exports = __webpack_public_path__ + "static/media/logo.dc611ae3.svg";